<template>
  <div
    data-testid="placeholder-element"
    class="placeholder-element"
    :style="{ width }"
    :class="{ outline, condense, flex, notpulse, dark }"
  >
    <slot />
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { useUserStore } from 'client/stores/user'

export const PlaceholderElement = {
  props: {
    outline: {
      type: Boolean,
      default: false
    },
    condense: {
      type: Boolean,
      default: false
    },
    flex: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '100%'
    },
    notpulse: {
      type: Boolean,
      default: false
    },
    light: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(useUserStore, ['contrast']),
    dark() {
      return !this.light && this.contrast === 1
    }
  }
}

export { default as PlaceholderBlock } from './PlaceholderBlock.vue'
export default PlaceholderElement

</script>

<style lang="scss">
.placeholder-element {
  margin: 8px 6px 6px 0;
  color: #fff;
  animation: placeholder-pulse-lm ease-in-out 3s infinite;

  &.dark {
    animation: placeholder-pulse ease-in-out 3s infinite;
  }

  &.notpulse {
    animation: none;
  }

  &.outline {
    padding: 8px;
    border: 2px solid #2d2f31;
    border-radius: 4px;

    & .placeholder-block {
      border-radius: 0 !important;
    }
  }

  &.flex {
    display: flex;
  }

  &.condense {
    padding: 0 !important;

    & .placeholder-blocks {
      margin: 0 !important;

      & .placeholder-block {
        margin: 0 !important;
      }
    }
  }

  .placeholder-blocks {
    &.flex {
      display: flex;
    }

    .placeholder-block {
      margin: 4px 8px 4px 0;
      background:
        linear-gradient(
          320deg,
          rgba(64, 67, 70, 1),
          rgba(64, 67, 70, 1),
          rgba(64, 67, 70, 1),
          rgba(91, 94, 98, 0.8),
          rgba(64, 67, 70, 1),
          rgba(64, 67, 70, 1),
          rgba(64, 67, 70, 1)
        );
      background-size: 400% 400%;
      border-radius: 3px;
      animation: placeholder-shimmer ease-out 3s infinite;
    }
  }

  @keyframes placeholder-pulse {
    0% { opacity: 1; }
    65% { opacity: 0.55; }
    100% { opacity: 1; }
  }

  @keyframes placeholder-pulse-lm {
    0% { opacity: 0.2; }
    65% { opacity: 0.1; }
    100% { opacity: 0.2; }
  }

  @keyframes placeholder-shimmer {
    0% { background-position: 100% 50%; }
    33% { background-position: 0% 50%; }
    33.1% { background-position: 100% 50%; }
    100% { background-position: 100% 50%; }
  }
}
</style>

